/* 日志工具类 */
const Logger = {
  getLogContent (prefix, title, desc, arg) {
    arg = arg || {}
    switch (prefix) {
      case 'debug': return `--debug ${title} - 描述：${desc} - 参数：`
      case 'info': return `--info ${title} - 描述：${desc} - 参数：`
      case 'warning' : return `--warning ${title} - 修改方案：${desc} - 参数：`
      case 'error': return `--error ${title} - 解决方案：${desc} - 参数：`
    }
  },
  debugLog (title, desc, arg) {
    if (this.isDebug()) { console.log(this.getLogContent('debug', title, desc), arg) }
  },
  /* 日志 */
  infoLog (title, desc, arg) {
    console.info(this.getLogContent('info', title, desc), arg)
  },

  errorLog (title, desc, arg) {
    console.error(this.getLogContent('error', title, desc), arg)
    throw new Error(title)
  },
  errorNELog (title, desc, arg) {
    console.error(this.getLogContent('error', title, desc), arg)
  },
  warningLog (title, desc, arg) {
    console.warn(this.getLogContent('warning', title, desc), arg)
  },
  isDebug () {
    const env = window._CONFIG || window._CONFIG.env
    if (env) {
      const profiles = env.profiles
      return profiles ? (profiles.indexOf('dev') === 0) : false
    } else {
      return true
    }
  }
}

export default Logger
